import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

const MAX_COUNT_LENGTH = 15;

export const useValidationSchemaAdministrationSyncEventFromHrm = () => {
  const { t } = useTranslation();

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      id: Yup.string()
        .trim()
        .required(t('errors.requiredField'))
        .matches(/(^$)|(^\d+$)/, t('errors.invalidFormat'))
        .max(MAX_COUNT_LENGTH, t('errors.maxCharacters', { count: MAX_COUNT_LENGTH }))

        .test('test', t('errors.moreThanZero'), function (amount) {
          return Number(amount) > 0;
        }),
    });
  }, [t]);

  return { validationSchema };
};
